import { PrismaClient } from 'scalis-db-v2'

declare global {
  // eslint-disable-next-line no-var
  var prismaScalisV2: PrismaClient | undefined
}

if (!global.prismaScalisV2) {
  global.prismaScalisV2 = new PrismaClient()
}

export const prismaClientScalisV2 = global.prismaScalisV2
